import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/Brands/IMG-20250911-WA0003.jpg")